<template>
  <div>
    <!-- Content -->
    <div class="">
      <p class="has-text-weight-bold mb-sm">Merchandising Contact</p>
      <p class="has-text-grey mb-md">
        In order to onboard new products with {{ connection.retailer.name }},
        you will be asked to provide item templates containing
        information about your products. Please select a merchandising
        representative that can provide product information and answer questions
        about your products.
      </p>
      <b-field
        class="py-sm"
        :type="('merchandising_manager' in errors) ? 'is-danger' : ''"
        :message="('merchandising_manager' in errors) ? errors['merchandising_manager'][0] : ''">
        <b-select
          v-model="merchandisingContact"
          placeholder="Select User"
          expanded>
          <option v-for="user in users" :key="user.id" :value="user.id">
            {{ user.first_name }} {{ user.last_name }}
          </option>
        </b-select>
      </b-field>
      <p>Need to invite a <a href="#" @click.prevent="$emit('invite:user')" class="has-text-info">new teammate?</a></p>
    </div>
    <!-- Navigate -->
    <div class="py-lg">
      <div class="columns is-centered">
        <div class="column">
          <b-button
            type="is-light rounded-lg"
            size="is-medium"
            @click="goBack"
            expanded
            ><b-icon icon="arrow-left"></b-icon>
          </b-button>
        </div>
        <div class="column">
          <b-button
            type="is-primary rounded-lg"
            size="is-medium"
            expanded
            @click="goForward"
            :disabled="saving"
            :loading="saving"
          >Save &amp; Continue</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['app', 'context'])
  },
  data () {
    return {
      merchandisingContact: null,
      saving: false,
      errors: {}
    }
  },
  methods: {
    goBack () {
      this.$emit('navigate', 'PrimaryContact')
    },
    goForward () {
      this.saving = true
      const endpoint = this.context.route + '/'
      const json = {
        merchandising_manager: { id: this.merchandisingContact }
      }
      this.$http.patch(endpoint, json).then(response => {
        this.saving = false
        this.$buefy.toast.open({ type: 'is-success', message: 'Contact Updated!' })
        this.$emit('contact:updated')
        if (this.connection.level === 'products_only') {
          this.$emit('navigate', 'Confirmation')
        } else {
          this.$emit('navigate', 'FulfillmentContact')
        }
      }).catch(error => {
        if (error.response && error.response.status === 400) {
          this.errors = error.response.data
        }
      })
    }
  },
  mounted () {
    this.merchandisingContact = (this.supplier.merchandising_manager) ? this.supplier.merchandising_manager.id : null
  },
  props: {
    connection: {
      type: Object,
      required: true
    },
    task: {
      type: Object,
      required: true
    },
    supplier: {
      type: Object,
      required: true
    },
    users: {
      type: Array,
      required: true
    }
  }
}
</script>
